import {
  customElement,
  DeesElement,
  property,
  html,
  TemplateResult,
  css,
  cssManager,
} from '@designestate/dees-element';

declare global {
  interface HTMLElementTagNameMap {
    'lele-loginpeek': LeleLoginPeek;
  }
}

@customElement('lele-loginpeek')
export class LeleLoginPeek extends DeesElement {
  public static demo = () => html`<lele-loginpeek></lele-loginpeek>`;

  constructor() {
    super();
  }

  public static styles = [
    cssManager.defaultStyles,
    css`
      :host {
        position: absolute;
        width: 100%;
        height: 100%;
        background: #000;
        color: #fff;
      }

      
    `,
  ];

  render() {
    return html`
      <iframe></iframe>
    `;
  }

  public firstUpdated() {
    const iframe = this.shadowRoot.querySelector('iframe');
    iframe.src = 'https://wikipedia.com'
  }
}
